import { connect } from 'react-redux';
import SimpleDataGrid from './SimpleDataGrid';

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimpleDataGrid);
